import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { PublicDataService } from 'src/app/core/services';
import { Pattern, RangeForm } from 'src/app/utils/constants';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent {
  messageForm: FormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly idUsuario: number,
    private dialogRef: MatDialogRef<ContactComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly publicData: PublicDataService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.dialogRef.disableClose = true;
    this.messageForm = this.formBuilder.group({
      nombre: [null, [Validators.required, Validators.pattern(Pattern.NAME)]],
      correo: [null, [Validators.required, Validators.pattern(Pattern.EMAIL)]],
      telefono: [
        null,
        [
          Validators.required,
          Validators.pattern(Pattern.NUMBER),
          Validators.minLength(RangeForm.MIN_PHONE),
        ],
      ],
      mensajeEnviar: [
        null,
        [Validators.required, Validators.pattern(Pattern.TEXT)],
      ],
    });
  }

  submit(): void {
    if (this.messageForm.invalid) {
      return;
    }
    const tmp = this.messageForm.value;
    const request = this.publicData.createMessage(
      tmp.nombre,
      tmp.correo,
      tmp.telefono,
      tmp.mensajeEnviar,
      this.idUsuario,
      this.publicData.idioma
    );
    request.subscribe((response) => {
      if (response.message === 'OK' && response.status === 1) {
        forkJoin([
          this.translate.get('success'),
          this.translate.get('message_sent'),
        ]).subscribe((translate) => {
          this.toastr.success(translate[1], translate[0].toUpperCase());
        });
        this.dialogRef.close();
        return;
      }

      forkJoin([
        this.translate.get('error'),
        this.translate.get('error_sending_message'),
      ]).subscribe((translate) => {
        this.toastr.error(translate[1], translate[0].toUpperCase());
      });
    });
  }
}
